import { NBAGameListItem } from "../../../../util/types";
import { getCellKey } from "./QuarterGrid/utils";
import { QUARTERS, MINUTES, PLAYER_SLOTS } from "./constants";

export const compareByGameDate = (
  a: NBAGameListItem,
  b: NBAGameListItem,
): number =>
  new Date(a.gameDateTimeUTC).getTime() -
  new Date(b.gameDateTimeUTC).getTime();

export const countMinutes = (
  playerId: number,
  quarter: string,
  slotAssignments: Record<string, number | null>
): number =>
  PLAYER_SLOTS.reduce(
    (count, slot) =>
      MINUTES.reduce(
        (c, minute) =>
          slotAssignments[getCellKey(quarter, minute, slot)] === playerId
            ? c + 1
            : c,
        count
      ),
    0
  );

export const canCarryOver = (
  quarter: string,
  slotAssignments: Record<string, number | null>
): boolean => {
  const quarterIndex = QUARTERS.indexOf(quarter);
  if (quarterIndex === 0) return false;

  const prevQuarter = QUARTERS[quarterIndex - 1];
  const lastMinute = MINUTES[MINUTES.length - 1];

  const prevQuarterFull = PLAYER_SLOTS.every(
    (slot) => slotAssignments[getCellKey(prevQuarter, lastMinute, slot)]
  );
  const currentQuarterEmpty = PLAYER_SLOTS.every((slot) =>
    MINUTES.every(
      (minute) => !slotAssignments[getCellKey(quarter, minute, slot)]
    )
  );

  return prevQuarterFull && currentQuarterEmpty;
};

export const hasAnyFilled = (
  quarter: string,
  slotAssignments: Record<string, number | null>
): boolean =>
  PLAYER_SLOTS.some((slot) =>
    MINUTES.some((minute) => slotAssignments[getCellKey(quarter, minute, slot)])
  );
